
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignLifeboat as ObiSignLifeboatElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-lifeboat.js';
 
 
 

 
 export const ObiSignLifeboat = createComponent({
   react: React,
   tagName: 'obi-sign-lifeboat',
   elementClass: ObiSignLifeboatElement,
   events: {
     
   }
  });
 
 